import Colon from '@/components/Colon';

export default function TotalPrice(props) {
  const { totalPrices, isShowPrice } = props;

  return (
    <p className="mb-[9px] mt-[7px] flex items-center justify-end text-[12px]">
      {isShowPrice === false ? (
        <></>
      ) : (
        <>
          <span className="text-[#949FAB]">
            总额
            <Colon />
          </span>
          <span className="text-[#333]">￥{totalPrices}</span>
        </>
      )}
    </p>
  );
}
